document.addEventListener('DOMContentLoaded', function() {
  const statBlocks = document.querySelectorAll('.graph-stat');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Get the elements
        const statBlock = entry.target;
        const numberElement = statBlock.querySelector('.graph-stat__number');
        const pieChartElement = statBlock.querySelector('.graph-stat__pie-chart');
        
        // Animate the number if it exists
        if (numberElement) {
          const statText = numberElement.textContent;
          let targetNumber;
          let isPercentage = false;
          
          // Check if the stat is a percentage or just a number
          if (statText.includes('%')) {
            targetNumber = parseInt(statText.replace('%', ''), 10);
            isPercentage = true;
          } else {
            // Handle numbers with commas, spaces, etc.
            targetNumber = parseInt(statText.replace(/[^0-9]/g, ''), 10);
          }
          
          if (!isNaN(targetNumber)) {
            animateCountUp(numberElement, targetNumber, isPercentage);
          }
        }
        
        // Animate the pie chart if it exists
        if (pieChartElement) {
          const percentage = pieChartElement.dataset.percentage;
          const pieChartValue = pieChartElement.querySelector('.pie-chart__value');
          
          if (pieChartValue) {
            setTimeout(() => {
              pieChartValue.style.strokeDasharray = `${percentage}, 100`;
            }, 100);
          }
        }
        
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.3
  });
  
  // Function to animate count up
  function animateCountUp(element, targetNumber, isPercentage) {
    const duration = 1500; // Animation duration in milliseconds
    const frameDuration = 1000 / 60; // 60fps
    const totalFrames = Math.round(duration / frameDuration);
    let frame = 0;
    let currentNumber = 0;
    
    // Store original text to preserve formatting
    const originalText = element.textContent;
    
    const counter = setInterval(() => {
      frame++;
      const progress = frame / totalFrames;
      currentNumber = Math.round(targetNumber * progress);
      
      if (isPercentage) {
        element.textContent = `${currentNumber}%`;
      } else {
        // Format number with commas if needed
        element.textContent = currentNumber.toLocaleString();
      }
      
      if (frame === totalFrames) {
        clearInterval(counter);
        element.textContent = originalText; // Restore original text to preserve exact formatting
      }
    }, frameDuration);
  }
  
  // Start observing all stat blocks
  statBlocks.forEach(block => {
    observer.observe(block);
  });
}); 